import { render } from "./ArtWorkCard.vue?vue&type=template&id=c96ec0aa"
import script from "./ArtWorkCard.vue?vue&type=script&lang=js"
export * from "./ArtWorkCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__